import React from 'react'
import './SettingsButton.css'
export default function SettingsButton({ label, onClick, disabled }) {
    return (
        <button className='settings-button' onClick={onClick} disabled={disabled}>
            {label}
        </button>
    )
}
